import { literal, struct } from 'io-ts/Decoder';

export const Ping = struct({
	type: literal('ping'),
});
